import React from "preact/compat";
import {CarBrandsListProps} from "@/elements-react/car-brands-list";
import {LayoutStyleTypes} from "@/util-react/layout.tsx";
import {useTranslation} from "react-i18next";
import {useServices} from "@/services-context.tsx";
import {useMemo, useState} from "preact/hooks";
import {PageSectionLayout} from "@/elements-react/page-section-layout";
import styles from "@/elements-react/car-brands-list/css/car-brands-list.module.scss";
import { Url } from "@/helpers/url";
import { Gtag } from "@/services/gtag";
import {Icon} from "@/elements-react/fix-icon";
import {FixButton} from "@/elements-react/fix-button";
import {FixLink} from "@/elements-react/fix-link";
import rightSvg from "@/assets/right-outlined.svg";
import downSvg from "@/assets/down-outlined.svg";
import classNames from "classnames";

export const CarBrandsListDefault: React.FC<CarBrandsListProps> = ({ type = LayoutStyleTypes.TYPE_LG }) => {
    const { t } = useTranslation();
    const services = useServices();
    const [showAll, setShowAll] = useState(false);

    const smMaxItemsCount = 10;
    const lgMaxItemsCount = 15;

    const brands = useMemo(() => {
        if (!services?.brands?.list) return [];
        return [...services.brands.list].sort((a, b) => a.name.localeCompare(b.name));
    }, [services]);

    const maxItemsCount = type === LayoutStyleTypes.TYPE_SM ? smMaxItemsCount : lgMaxItemsCount;
    const shouldShowButton = !showAll && brands.length > maxItemsCount;

    const visibleBrands = useMemo(() => {
        if (shouldShowButton) {
            return brands.slice(0, maxItemsCount);
        }
        return brands;
    }, [brands, shouldShowButton, maxItemsCount]);

    if (!brands.length) return null;

    return (
        <PageSectionLayout type={type} sectionTitle={t("22462yo1x6yur1ek.car-brands-title" as any, "Buy car parts from the most popular car brands" as any)}>
            <div className={classNames(styles.itemList, { [styles.sm]: type === LayoutStyleTypes.TYPE_SM })}>
                {visibleBrands.map((item) => (
                    <FixLink
                        className={styles.item}
                        href={Url.to("dynamic-route", { dynamicPath: [item.slug] })}
                        onClick={() => Gtag.pushEvent("car_brand_click", item.name)}
                        key={item.slug}
                    >
            <span className={styles.itemInner}>
              <span className={styles.itemText}>{item.name}</span>
              <Icon src={rightSvg as string} width={8} />
            </span>
                    </FixLink>
                ))}
            </div>
            {shouldShowButton && (
                <div className={styles.controls}>
                    <FixButton
                        className={classNames(styles.buttonMore, { [styles.sm]: type === LayoutStyleTypes.TYPE_SM })}
                        exportparts="base:base"
                        suffix={<Icon src={downSvg as string} width={8} />}
                        variant={'more'}
                        onClick={() => {
                            Gtag.pushEvent("more_car_brand_click", "");
                            setShowAll(true);
                        }}
                    >
                        {t("76vwwhyjifi741oi.more-car-brands" as any, "More car brands" as any)}
                    </FixButton>
                </div>
            )}
        </PageSectionLayout>
    );
};